import type { FC } from 'react';
import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface Props {
  editable: boolean | undefined;
}

const EditorState: FC<Props> = props => {
  const [editor] = useLexicalComposerContext();
  const editable = Boolean(props.editable);

  useEffect(() => {
    if (editable !== editor.isEditable()) {
      editor.setEditable(editable);
    }
  }, [editor, editable]);

  return null;
};

export default EditorState;
